import React from 'react';
import "./hiremadeeasy.scss"
import {   useNavigate } from 'react-router-dom';

const HireMadeEasy = () => {
  const navigate = useNavigate()
  return (
    <div className='hiremade-easy'>
      <div className="hiremade-easy-container">
        <div className="hiremade-easy-flex1">
            <img src="/image/hiremadeeasy.webp" alt="" />
        </div>
        <div className="hiremade-easy-flex2">

            <h4>Find the <span style={{color:"#FF3131"}}>perfect talent</span>  for Your next project or job</h4>
            
            <div className="hire-made-easy-boxes">
                <h5>Free to Get Started</h5>
                <p>Join today and explore a wide network of skilled professionals, browse opportunities, or schedule a consultation—at no cost.</p>
            </div>
            <div className="hire-made-easy-boxes">
                <h5>Post Jobs and Find Experts</h5>
                <p>Easily post your projects or job openings, and connect with industry-leading talent to bring synergies to  your business.</p>
            </div>
            <div className="hire-made-easy-boxes">
                <h5>Quality Talent at Competitive Rates
                </h5>
                <p>Collaborate with top-tier professionals while staying within your budget, ensuring quality without compromise.</p>
            </div>
            <div className="hiremade-easy-button">
              
                <button onClick={()=>navigate('/job-recuiter-login')}>Sign up for free</button>
                {/* <button>Learn how to hire</button> */}
            </div>
        </div>

      </div>
    </div>
  )
}

export default HireMadeEasy
